export default __webpack_public_path__ + "img/3008913345a22e1501283b0e95ee6987.png";